var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEllipsis(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4759_8702)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.4935 16.0067C17.4935 16.3033 17.4056 16.5933 17.2407 16.84C17.0759 17.0867 16.8416 17.2789 16.5676 17.3925C16.2935 17.506 15.9919 17.5357 15.7009 17.4778C15.4099 17.42 15.1426 17.2771 14.9329 17.0673C14.7231 16.8575 14.5802 16.5903 14.5224 16.2993C14.4645 16.0083 14.4942 15.7067 14.6077 15.4326C14.7212 15.1585 14.9135 14.9243 15.1602 14.7594C15.4068 14.5946 15.6969 14.5067 15.9935 14.5067C16.3914 14.5067 16.7729 14.6647 17.0542 14.946C17.3355 15.2273 17.4935 15.6088 17.4935 16.0067ZM24.4935 14.5067C24.1969 14.5067 23.9068 14.5946 23.6602 14.7594C23.4135 14.9243 23.2212 15.1585 23.1077 15.4326C22.9942 15.7067 22.9645 16.0083 23.0224 16.2993C23.0802 16.5903 23.2231 16.8575 23.4329 17.0673C23.6426 17.2771 23.9099 17.42 24.2009 17.4778C24.4919 17.5357 24.7935 17.506 25.0676 17.3925C25.3416 17.2789 25.5759 17.0867 25.7407 16.84C25.9056 16.5933 25.9935 16.3033 25.9935 16.0067C25.9935 15.6088 25.8355 15.2273 25.5542 14.946C25.2729 14.6647 24.8914 14.5067 24.4935 14.5067ZM7.49353 14.5067C7.19686 14.5067 6.90685 14.5946 6.66018 14.7594C6.4135 14.9243 6.22124 15.1585 6.10771 15.4326C5.99418 15.7067 5.96448 16.0083 6.02235 16.2993C6.08023 16.5903 6.22309 16.8575 6.43287 17.0673C6.64265 17.2771 6.90992 17.42 7.2009 17.4778C7.49187 17.5357 7.79347 17.506 8.06756 17.3925C8.34165 17.2789 8.57591 17.0867 8.74074 16.84C8.90556 16.5933 8.99353 16.3033 8.99353 16.0067C8.99353 15.6088 8.8355 15.2273 8.55419 14.946C8.27289 14.6647 7.89136 14.5067 7.49353 14.5067Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4759_8702",
    x: -2,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4759_8702"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4759_8702",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipsis);
export default __webpack_public_path__ + "static/media/ellipsis.0bb338dbce89b82c09bf8b4d08a9eeb1.svg";
export { ForwardRef as ReactComponent };